let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5wnOQ")).then(() => parcelRequire('dacr9'));